<p-progressSpinner class="resy_spinner" *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="display_block_mbl d-flex flex-row justify-content-between pb-2">
    <div class="w-50 w_100_mbl">
      <label class="lbl_resy_field">{{'VENUE.NAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Name']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['Name']|translate}}"
           tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="capacityTemplateModel.name">
    </div>
    <div class="w-50 w_100_mbl" style="max-width: 305px !important;">
      <label class="lbl_resy_field">{{'VENUE.DATE_AND_TIME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['DateRange']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['DateRange']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-calendar #rangeCalendar class="range-date-picker" [(ngModel)]="dateRange"
                  selectionMode="range" [readonlyInput]="true" inputId="range" [showIcon]="true" [autoZIndex]="false"
                  [firstDayOfWeek]="1" styleClass="higher-input" [touchUI]="isTouch">
        <ng-template pTemplate="date" let-date>
          <div class="calendar-item"
               [ngClass]="{range_selecting: isRangeDate(date, 0, true),
                             endpoint_start: isRangeDate(date, 0),
                             endpoint_end: isRangeDate(date, 1)}">
            <span class="date">{{ date.day }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="footer">
          <div class="w-100 d-flex flex-row mt-4">
            <div class="w-50">
              <label class="time_lbl">{{'RESERVATION.START_TIME' | translate}}:</label>
              <p-calendar [(ngModel)]="fromTime" [timeOnly]="true" [inline]="true" inputId="timeonly"
                          [hourFormat]="'12'"></p-calendar>
            </div>
            <div class="w-50">
              <label class="time_lbl ps-0">{{'RESERVATION.END_TIME' | translate}}:</label>
              <p-calendar [(ngModel)]="toTime" [timeOnly]="true" [inline]="true" inputId="timeonly"
                          [hourFormat]="'12'"></p-calendar>
            </div>
          </div>
        </ng-template>
      </p-calendar>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-between">
    <button *ngIf="!editEnabled" class="btn_login w-50" (click)="addCapacityTemplate(capacityTemplateModel)">{{ 'ADD' | translate}}</button>
    <button *ngIf="editEnabled" class="btn_login w-50" (click)="editCapacityTemplateDates(capacityTemplateModel)">{{ 'EDIT' | translate}}</button>
    <button class="btn_without_color w-50" (click)="cancel()">{{ 'CANCEL' | translate}}</button>
  </div>
</div>
